import { render, staticRenderFns } from "./EditorProperties.vue?vue&type=template&id=fed1bb7e&scoped=true&"
import script from "./EditorProperties.vue?vue&type=script&lang=js&"
export * from "./EditorProperties.vue?vue&type=script&lang=js&"
import style0 from "./EditorProperties.vue?vue&type=style&index=0&id=fed1bb7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed1bb7e",
  null
  
)

export default component.exports